import React from "react";
import { Link } from "react-router-dom";

import GlobalImage from "../../../../global/image/image";
import LikeProperty from "../../../../global/like-property";
import StarRating from "../../../../global/star-rating/StarRating";
import NoImage from "../../../../../assets/image_not_supported.svg";
import CurrencyConvertor from "../../../../global/currency-convertor";
import { replaceImageUrlSize } from "../../../../../utils/image";
import UserInputViewer from "../../../../global/UserInputViewer";

import "./styles.css";
import toggleClass from "../../../../../utils/dom/toggle-class.util";

const PropertyDertailsMobileView = ({ property, params, setAvailableProperties }) => {
  const checkinDate = params?.bookingDates?.checkinDate;
  const checkoutDate = params?.bookingDates?.checkoutDate;
  const adults = params?.guests?.adultCount;
  const childs = params?.guests?.childCount;
  const _childAges = params?.guests?.childAges;
  const rooms = params?.guests?.roomCount;

  function getNumberOfNights(checkInDateStr, checkOutDateStr) {
    const oneDayMs = 86400000;
    const checkInDate = new Date(checkInDateStr);
    const checkOutDate = new Date(checkOutDateStr);
    const timeDiffMs = checkOutDate.getTime() - checkInDate.getTime();
    return Math.ceil(timeDiffMs / oneDayMs);
  }
  const numberOfNights = getNumberOfNights(checkinDate, checkoutDate);

  const basePrice = property?.basePrice;
  const finalPrice = property?.finalPrice;

  const TotalTaxRate = property?.totalTaxRate ?? 0;
  const tax = TotalTaxRate * finalPrice;

  const hippoOfferRate = property.hippoOfferRate ? Number((property.hippoOfferRate * 100).toFixed(2)) : 0;

  let discountType = hippoOfferRate > 0 ? "hippoOffer" : "";

  const navigateURL = `/property/${property?.id}/${property?.name}?checkin=${checkinDate}&checkout=${checkoutDate}&adults=${adults}&children=${
    childs ?? 0
  }${_childAges}&rooms=${rooms}`;

  return (
    <Link to={navigateURL} target="_blank" className="mobile-view-property-details-card">
      <div className="property-details-modal-image">
        {property?.defaultImage ? (
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={replaceImageUrlSize(property?.defaultImage, "medium")}
              alt="Building"
              className="building skeleton-loading"
            />
            <GlobalImage src={replaceImageUrlSize(property?.defaultImage, "square")} alt="Building" className="property-image " loading="lazy" />
          </picture>
        ) : (
          <img
            src={NoImage}
            alt="Not Available"
            className="building"
            onLoad={(e) => {
              toggleClass(e.target, "skeleton-loading");
            }}
          />
        )}
        <div
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          className="like-property-icon"
        >
          <LikeProperty
            propertyId={property?.id}
            isLiked={property?.isLiked}
            handleLike={(propertyId, liked) => {
              setAvailableProperties((prev) => {
                return prev.map((property) => {
                  if (property.id === propertyId) {
                    return { ...property, isLiked: !liked };
                  }
                  return property;
                });
              });
            }}
          />
        </div>
      </div>
      <div className="property-details">
        <div className="property-details-modal-text">
          <UserInputViewer tag="h4" className="property-name" text={property.name} />
          {property?.reviewSummary.reviewerCount > 0 && (
            <div className="property-details-reviews">
              <StarRating rating={property?.rating} />
              <div className="reviews-over-all-score">{property?.reviewSummary.overallScore.toFixed(1)}</div>
              <div className="review-count">
                {property?.reviewSummary.reviewerCount} review
                {property?.reviewSummary.reviewerCount > 1 && "s"}
              </div>
            </div>
          )}
        </div>
        <div className="property-details-extra-details">
          <div className="property-type">
            {property.availableRooms.map((roomType, index) => (
              <div key={index}>
                {index !== 0 && " , "}
                {`${roomType.rateplan.selectedUnits} x ${roomType.name} `}
              </div>
            ))}
          </div>
          <div className="adult-count">
            price for{" "}
            <span>
              {numberOfNights} Night
              {numberOfNights > 1 ? "s" : ""}, {adults} Adult
              {adults > 1 ? "s" : ""}
            </span>
          </div>
          <div className="price-adult-count">
            {basePrice !== finalPrice && <CurrencyConvertor className="cut-price" price={basePrice} />}
            <CurrencyConvertor price={finalPrice} primaryDiscountType={discountType} className="final-price" />
          </div>
          {TotalTaxRate > 0 ? (
            <div className="include-tax">
              +<CurrencyConvertor price={tax} />
              &nbsp; taxes and charges
            </div>
          ) : (
            <div className="include-tax">Includes taxes and charges</div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default PropertyDertailsMobileView;
